module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALBAMAAABBvoqbAAAAKlBMVEUAAADDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8haGoHfAAAADXRSTlMA1w8Wxh7dzL69MRq//EO/gAAAAC1JREFUCNdjWGHAwMAwVxhIqF/cwMDA5CsKZKpcC2BgYL57AMwCiYFlIerAOgA6Xwtd5MfYFQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_next1_hover.png
// module id = c4nL
// module chunks = 9